<script setup>
import { ref, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t } = useI18n();
const route = useRoute();
const accountId = computed(() => route.params.accountId);

const token = ref('');

const iframeSrc = computed(() => {
  if (!accountId.value || !token.value) return '';
  return `/chatflow_proxy/accounts/${accountId.value}/workflow/view?token=${encodeURIComponent(
    token.value
  )}`;
});

onMounted(async () => {
  const response = await window.axios.get(
    `/api/v1/accounts/${accountId.value}/chatflow_proxy_token`
  );
  token.value = response?.data?.token || '';
});
</script>

<template>
  <iframe
    :src="iframeSrc"
    :title="t('SIDEBAR.CHATFLOW')"
    class="w-full h-full overflow-hidden"
  />
</template>
